import APIHandler from "api/api-handler";

const latestVersionAPI = {
  fetchLatestVersion: () => APIHandler.get({ url: `${window.location.origin}/releaseData.json` })
};

export default latestVersionAPI;
